import { ArrowRight, LayoutGrid } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

const ExecutiveCTASection = () => {
  return (
    <section className="py-20 md:py-28 bg-foreground">
      <div className="max-w-3xl mx-auto px-6 sm:px-8 lg:px-12 text-center">
        <span className="text-xs font-medium text-primary tracking-wide uppercase">The Larkin Standard</span>

        <h2 className="text-3xl md:text-4xl font-bold text-white tracking-tight mt-4 mb-4">
          Experience the Larkin Standard.
        </h2>
        <p className="text-lg text-white/60 mb-10 leading-relaxed max-w-xl mx-auto">
          Ready to eliminate procedure revenue leakage?
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button
            size="lg"
            className="bg-cta hover:bg-cta/90 text-cta-foreground font-bold px-8 py-4 text-lg rounded-md min-h-[48px]"
          >
            Schedule a Revenue Integrity Audit
            <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
          <Button
            variant="outline"
            size="lg"
            asChild
            className="border-white/20 hover:bg-white/10 text-white px-8 py-4 text-lg min-h-[48px] rounded-md"
          >
            <Link to="/platform">
              <LayoutGrid className="mr-2 h-5 w-5" />
              View Specialty Rulesets
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ExecutiveCTASection;
